export const ENV = process.env.REACT_APP_ENV
export const REK = process.env.REACT_APP_REK
export const MIXPANEL_TOKEN = process.env.REACT_APP_MIXPANEL_TOKEN
export const RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY
export const ELEVENLABS_API_KEY = process.env.REACT_APP_TEXT_TO_VOICE_EVENLABS_KEY
export const API_XANO_BASE_URL = process.env.REACT_APP_XANO_BASE_URL

const DEFAULT_NINJACURATE_BACKEND_BASE_URL = 'https://ninjacurate.learntube.ai'
const DEFAULT_PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL = 'http://localhost:8000'

export const NINJACURATE_BACKEND_BASE_URL = (
    process.env.REACT_APP_NINJACURATE_BACKEND_BASE_URL || DEFAULT_NINJACURATE_BACKEND_BASE_URL
).replace(/\/+$/, '')

export const PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL = (
    process.env.REACT_APP_PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL || DEFAULT_PERSONALISED_VIDEO_PLAYER_BACKEND_BASE_URL
).replace(/\/+$/, '')
